import React from 'react';

import { Table } from '@/js/libs/ui/src/V2';

import type { Column, CustomColumnProps } from '../types';

export interface TaskRowProps extends CustomColumnProps {
  columns: Column[];
}

export const TaskRow: React.FC<TaskRowProps> = React.memo(function TaskRow({ columns, ...props }) {
  return (
    <Table.Row>
      {columns.map((column) => {
        const { name, component: Component } = column;

        return (
          <Table.Cell {...column} key={name} dataTestId={`${name}-cell`}>
            {Component && <Component column={column} {...props} />}
          </Table.Cell>
        );
      })}
    </Table.Row>
  );
});
